import React from 'react';

const DOCUMENT_ICON_MASK = `url(${process.env.PUBLIC_URL || ''}/Document.svg)`;

const DocumentActionIcon: React.FC = () => (
  <span
    className="cp-btn-annual-action-document-icon"
    aria-hidden
    style={{ WebkitMaskImage: DOCUMENT_ICON_MASK, maskImage: DOCUMENT_ICON_MASK }}
  />
);

export default DocumentActionIcon;
